module.exports = __webpack_public_path__ + "static/media/IMG_0256.80ab96e1.jpeg";